// Generated types for FunctionalSubsystem
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { ActionDefinitionReadAPI, ActionDefinitionWriteAPI } from '../../sysml/types/actiondefinition';
import { ActionDefinitionReadAPISchemaObject, ActionDefinitionWriteAPISchemaObject } from '../../sysml/types/actiondefinition';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface FunctionalSubsystemReadAPI extends ActionDefinitionReadAPI {
}

export interface FunctionalSubsystemWriteAPI extends ActionDefinitionWriteAPI {
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const FunctionalSubsystemReadAPISchema: z.ZodType<FunctionalSubsystemReadAPI> = ActionDefinitionReadAPISchemaObject.extend({}).passthrough();

export const FunctionalSubsystemWriteAPISchema: z.ZodType<FunctionalSubsystemWriteAPI> = ActionDefinitionWriteAPISchemaObject.extend({}).passthrough();
